import React from 'react';
import AppIcon from '../ui/AppIcon';

const AdminPage = () => {
  return (
    <div className="container">
      <div className="text-center mt-5">
        <AppIcon size={60} />
        <h1>Admin Panel</h1>
        <p>Content management dashboard</p>
        <p>Admin functionality coming soon...</p>
      </div>
    </div>
  );
};

export default AdminPage;
